import { useMemo } from 'react';
import { type NavigateOptions, useNavigate } from 'react-router-dom-v5-compat';

interface HistoryObject {
  navigate: ReturnType<typeof useNavigate>;
  push: (path: string, options?: NavigateOptions) => void;
  replace: (path: string, options?: NavigateOptions) => void;
  goBack: () => void;
}

/**
 * Hook that provides a history object with navigation methods
 * @returns Object containing navigation methods (navigate, push, replace, goBack)
 */
export const useHistory = (): HistoryObject => {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      navigate,
      push: (path: string, options?: NavigateOptions) => navigate(path, options),
      replace: (path: string, options?: NavigateOptions) =>
        navigate(path, { ...options, replace: true }),
      goBack: () => navigate(-1),
    }),
    [navigate]
  );
};
